import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { useLogout } from '../hooks/useLogout'
import { useNavigate } from "react-router-dom"
import { Tooltip } from '@mui/material';

export default function MenuAppBar({ appbarTitle }) {
  const [auth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { logout } = useLogout()
  let navigate = useNavigate()


  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const doLogout = () => {
    logout()
    navigate("/login")
  };

  return (
    <Box >
      <AppBar position="static">
        <Toolbar>
          {/* <Tooltip title="Minimer/maksimer sidemeny">
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
            >
              <MenuIcon onClick={handleCollapse} />
            </IconButton>
          </Tooltip> */}

          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {appbarTitle}
          </Typography>
          {auth && (
            <div>
              {/* <Tooltip title="Programadministrasjon">
                <IconButton
                  size="large"
                  aria-label="programadmin"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={gotoProgAdmin}
                  color="inherit"
                >
                  <SourceIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Statistikk">
                <IconButton
                  size="large"
                  aria-label="reports"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={gotoReports}
                  color="inherit"
                >
                  <PieChartIcon />
                </IconButton>
              </Tooltip> */}

              <Tooltip title="Konto">
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  <AccountCircle />
                </IconButton>
              </Tooltip>

              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={doLogout}>Logg ut</MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}